import { useRef } from "react";

export default function DebouncesTextInput({ onChange, onTyping, defaultValue, placeholder, className }) {
    const debounceTimeout = useRef();

    const handleChange = (e) => {
        const value = e.target.value;
        onTyping && onTyping(value)
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            onChange && onChange(value);
        }, 1000); // 300ms debounce
    };

    return (<input className={className} placeholder={placeholder} defaultValue={defaultValue}
        onChange={handleChange}
        onBlur={e => onChange && onChange(e.target.value)}
    />)
}
